import React from 'react';
import { User, ArrowLeft } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';

export const EmployeeOnboarding = () => {
  const [userEmail, setUserEmail] = React.useState<string>('');
  const navigate = useNavigate();

  React.useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user?.email) {
        setUserEmail(user.email);
      }
    };
    getUser();
  }, []);

  return (
    <div className="min-h-screen bg-[#EFF0F5] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Back Button */}
        <button
          onClick={() => navigate('/onboarding')}
          className="mb-6 flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Volver</span>
        </button>

        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <img src="https://kywexemefeblsysfxkpu.supabase.co/storage/v1/object/public/system//Logo.svg" alt="Atlas logo" className="w-20 h-20" />
          <div className="flex flex-col">
            <span className="text-4xl font-bold tracking-wider" style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>ATLAS</span>
            <span className="text-xs font-light tracking-[0.1em] text-gray-600">SISTEMA IA</span>
          </div>
        </div>

        {/* Message Card */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="flex flex-col items-center text-center">
            <User className="w-16 h-16 text-blue-500 mb-4" />
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Solicitud de acceso
            </h2>
            <p className="text-gray-600 mb-6">
              Solicita a tu jefe/gerente que te añada como empleado de la empresa. Para esto debe dirigirse a la sección de Configuración &gt; Empresa y en el campo de añadir miembro debe introducir tu correo:
            </p>
            <div className="bg-blue-50 p-4 rounded-lg mb-4 w-full">
              <p className="text-blue-700 font-medium break-all">{userEmail}</p>
            </div>
            <p className="text-sm text-gray-500 italic">
              Dile que se asegure de introducir el mail correctamente
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};